import { Droplets, Thermometer, CloudRain } from "lucide-react";

const DemoMetrics = () => {
  const metrics = [
    {
      icon: Droplets,
      label: "Sol",
      value: "42%",
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      icon: Thermometer,
      label: "Temp",
      value: "22°C",
      color: "text-orange-600",
      bgColor: "bg-orange-50",
    },
    {
      icon: CloudRain,
      label: "Humidité",
      value: "65%",
      color: "text-cyan-600",
      bgColor: "bg-cyan-50",
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-2">
      {metrics.map((metric) => (
        <div
          key={metric.label}
          className={`${metric.bgColor} rounded-xl p-2.5 text-center border border-slate-100`}
        >
          <metric.icon className={`w-4 h-4 ${metric.color} mx-auto mb-1`} />
          <div className={`text-sm font-bold ${metric.color}`}>{metric.value}</div>
          <div className="text-[9px] text-slate-500">{metric.label}</div>
        </div>
      ))}
    </div>
  );
};

export default DemoMetrics;
